import React, { Component } from 'react'

class VT extends Component {
  render() {
    return (
      <symbol id="statesvg-VT" width="100" height="100" viewBox="0 0 100 100">
        <path d="M78.07,20.05l-1.21.37-.25,2.18-2.3,3-5.46,4.24-3.63.24-1.94,2.67L63,40.06,61,44.67l.61,1-2.43,3.87-1.09,4.13-2.79,2.91-.84,4.61-1.58,2.42-.49,10.67-1,2.06L50.06,86.62l-1.45,1.45-1,4.12.36,2,2.3,4.36L25.93,97.41,24.84,95l1.58-31.4-1.94-3H23.14l-1.94,2.3-.36-1.69,2.06-7.28L20.84,42l1.7-5.82,1.69-1.94-.24-5,1.34-3.76-2.55-7.4,1.45-6.91L22.9,8.29l1.33-3.64L24,2,79.16,1.5l-.85,1.7L79,6.47l-3,4-.73,2.67,2.79,6.06Z" />
      </symbol>
    )
  }
}

export default VT
